module.exports = __webpack_public_path__ + "img/open-preview.201512cb.svg";